// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Ykct","requiredAsterisk":"Info_requiredAsterisk__nzoFj"};